import React, { Component } from 'react';
import { Layout, Menu, message } from 'antd';
import './menuLayout.styl';
import store from 'store';
import { getParam } from 'ruigu-utils';
import { qtPagePvFun, getMenuInfoByUrl, getMenuInfoById, getArray, getMenuLayoutById, isQuickBIReportUrl, fetchQuickBIReportUrl } from '@/utils/util';
import { menu } from '@/api/index';
import { PROTOCOL } from '@/utils/messageProtocol';

const { Content, Sider } = Layout;

// 递归处理
function routerItem(arr) {
  return arr.map((element) => {
    const item = {
      label: element.title,
      key: element.id,
      icon: element.icon ? (
        <img
          src={element.icon}
          preview={false}
          className="router-item-icon"
          alt="图片"
        />
      ) : (
        ''
      ),
      path: element.path,
    };
    if (element.children && element.children.length > 0) {
      item.children = routerItem(element.children);
    }
    return item;
  });
}

// 递归获取第一个地址
function pathFirstRouter(arr, keys = []) {
  for (const element of arr) {
    const newKeys = [String(element.id), ...keys];
    if (element.children && element.children.length > 0) {
      return pathFirstRouter(element.children, newKeys);
    } else {
      return {
        ...element,
        openKeys: newKeys,
      };
    }
  }
}

function returnPath(path, id) {
  const iframeSplit = (path || '').split('?');
  return `${iframeSplit[0]}?${
    iframeSplit[1] ? iframeSplit[1] + '&' : ''
  }id=${id}&_t=${Math.random() * 1e18}`;
}

export default class Compon extends Component {
  state = {
    iframeSrc: '',
    openModule: {},
    routerMenu: [],
    openKeys: [],
    selectedKeys: [],
    systemList: [],
  };

  componentDidMount() {
    const storeOpenModule = store.get('openModule') || [];
    const storeItem =
      storeOpenModule.find((item) => item.id == getParam('id')) || {};
    if (!storeItem.children || !storeItem.children.length) return;
    const { path, openKeys, id } = String(storeItem.id || '').startsWith('home')
      ? storeItem.children.find((item) => item.id == getParam('id'))
      : pathFirstRouter(storeItem.children);
    this.loadIframeSrc(path, id, {
      openModule: storeItem,
      routerMenu: routerItem(storeItem.children || []),
      openKeys,
      selectedKeys: String(id),
    });
    // 初始化上报
    qtPagePvFun(path);
    window.addEventListener('message', ({ data }) => {
      if (data.url) {
        if (!data.isOpenNewTab && data.isMenuLayout) {
          return;
        }
        // 判断目标跳转是否在当前模块内
        const { url, menuUrl, id, isMenuLayout } = data;
        // 01判断是否在左边菜单栏内：回溯寻找顶部和左侧菜单
        let stateInfo = {};
        if (menuUrl) {
          stateInfo = getMenuInfoByUrl(this.state.openModule.children, [], menuUrl);
        } else if (id && id != -1) {
          stateInfo = getMenuInfoById(this.state.openModule.children, [], id);
        }
        if (stateInfo) {
          this.loadIframeSrc(url, stateInfo.id, {
            openKeys: stateInfo.openKeys,
            selectedKeys: `${stateInfo.id}`,
          });
          return;
        }

        // 02判断是否跳转menuLayout页面
        if (isMenuLayout) {
          this.hrefMenuLayoutByMenuList(data);
          return;
        }

        // 03新开标签页
        window.parent.postMessage(
          {
            ...data,
            isMenuLayout: true,
          },
          '*',
        );
      }
    });

    // 监听子应用 access_token 请求（消息回投）
    window.addEventListener('message', this.handleTokenRequest);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleTokenRequest);
  }

  /**
   * 设置 iframe 地址：报表 URL 先换票再设置，其余 URL 直接设置
   */
  loadIframeSrc(path, id, extraState = {}) {
    const src = returnPath(path, id);
    if (!isQuickBIReportUrl(path)) {
      this.setState({ iframeSrc: src, ...extraState });
      return;
    }
    // 菜单选中态立即更新，报表地址待换票完成后再设置
    this.setState({ ...extraState });
    fetchQuickBIReportUrl(src)
      .then((url) => {
        this.setState({ iframeSrc: url });
      })
      .catch(() => {
        // 换票失败时 iframe 保持空白
      });
  }

  /**
   * 处理子应用 access_token 请求：只认本页 iframe 子窗，
   * token 实时取自登录态，只回投给消息真实来源 origin
   */
  handleTokenRequest = (event) => {
    const { data, origin, source } = event;
    // ① 协议过滤
    if (!data || data.type !== PROTOCOL.REQ) return;
    console.log('[iframe-token] menuLayout 收到子应用 token 请求:', origin);
    // ② 只认自家 iframe 子窗
    const iframe = this.iframeRef;
    if (!iframe || iframe.contentWindow !== source) return;
    // ③④ 回投实时 token，只发给消息真实来源，绝不用 "*"
    const token = store.get('token') || '';
    console.log(
      '[iframe-token] menuLayout 回投 token:',
      origin,
      token ? `${token.slice(0, 8)}...(len=${token.length})` : '(空)',
    );
    source.postMessage(
      { type: PROTOCOL.RES, access_token: token },
      origin,
    );
  };

  // 查询接口递归出目录跳转
  hrefMenuLayoutByMenuList = async (data) => {
    try {
      const menuList = getArray(await menu()).filter(
        (item) => getArray(item.children).length > 0,
      );
      const id = String(data.systemId || data.id || data.title);
      const menuInfo = getMenuLayoutById(menuList, id);
      window.parent.postMessage({
        ...menuInfo,
        ...data,
        id,
        children: menuInfo.children,
        url: `${window.location.origin}/menuLayout`,
      });
    } catch (err) {
      message.warning(err.message);
    }
  }

  onMenuClick = (e) => {
    const {
      item: {
        props: { path },
      },
      keyPath: openKeys,
      key,
    } = e;
    if (path.startsWith('https://doc.weixin.qq.com')) {
      return window.open(path);
    }
    this.loadIframeSrc(path, key, {
      openKeys,
      selectedKeys: [key],
    });
    // 切换上报
    qtPagePvFun(path);
  };

  onMenuOpen = (openKeys) => {
    this.setState({
      openKeys,
    });
  };

  render() {
    const { openModule, routerMenu, iframeSrc, openKeys, selectedKeys } =
      this.state;
    return (
      <Layout className="menuLayout">
        <Sider width={220} className="site-layout-background">
          {openModule.title ? (
            <div className="flex-row-center-center logo">
              {openModule.icon ? (
                <img
                  className="icon"
                  src={openModule.icon}
                  alt=""
                />
              ) : ''}
              <span>{openModule.title}</span>
            </div>
          ) : (
            ''
          )}
          <Menu
            mode="inline"
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            className={
              openModule.title ? 'menuLayout-menu' : 'menuLayout-menu-100vh'
            }
            items={routerMenu}
            onClick={this.onMenuClick}
            onOpenChange={this.onMenuOpen}
          />
        </Sider>
        <Layout>
          {/* {openModule.isTenant ? (
            <IndexNavigation
              systemList={this.state.systemList}
              onClickNavigation={this.onClickNavigation.bind(this)}
            />
          ) : ''} */}
          <Content
            className="site-layout-background"
            style={{
              margin: 0,
            }}
          >
            {iframeSrc && (
              <iframe
                ref={(iframe) => (this.iframeRef = iframe)}
                src={iframeSrc}
                className="iframeSrc"
              />
            )}
          </Content>
        </Layout>
      </Layout>
    );
  }
}
